import React from "react";

type NoFaceProps = {
  color?: string;
  size?: number;
};

const NoFace: React.FC<NoFaceProps> = ({ color = "#000", size = 20 }) => {
  return (
    <svg
      width={size}
      height={(size * 21) / 20}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14203_4584)">
        <path
          d="M7.4987 12.3748C8.07399 12.3748 8.54036 11.9085 8.54036 11.3332C8.54036 10.7579 8.07399 10.2915 7.4987 10.2915C6.9234 10.2915 6.45703 10.7579 6.45703 11.3332C6.45703 11.9085 6.9234 12.3748 7.4987 12.3748Z"
          fill={color}
        />
        <path
          d="M14.5822 8.83317C15.2072 8.83317 15.8072 8.75817 16.3905 8.63317C16.5655 9.22484 16.6655 9.84984 16.6655 10.4998C16.6655 11.5165 16.4322 12.4748 16.0238 13.3332L17.2655 14.5748C17.9405 13.3665 18.3322 11.9832 18.3322 10.4998C18.3322 5.89984 14.5988 2.1665 9.99883 2.1665C8.51549 2.1665 7.13216 2.55817 5.92383 3.23317L10.3655 7.67484C11.6072 8.40817 13.0405 8.83317 14.5822 8.83317ZM8.88216 3.93317C9.24049 3.87484 9.61549 3.83317 9.99883 3.83317C12.4155 3.83317 14.5322 5.13317 15.6988 7.0665C15.3405 7.12484 14.9655 7.1665 14.5822 7.1665C12.1655 7.1665 10.0488 5.8665 8.88216 3.93317Z"
          fill={color}
        />
        <path
          d="M1.57422 3.5998L3.39922 5.4248C2.31589 6.83314 1.66589 8.59147 1.66589 10.4998C1.66589 15.0998 5.39922 18.8331 9.99922 18.8331C11.9076 18.8331 13.6659 18.1831 15.0742 17.0998L16.8992 18.9248L18.0742 17.7498L2.75755 2.4248L1.57422 3.5998ZM13.8826 15.9081C12.7909 16.6998 11.4492 17.1665 9.99922 17.1665C6.32422 17.1665 3.33255 14.1748 3.33255 10.4998C3.33255 10.4581 3.34089 10.4165 3.33255 10.3831C4.49089 9.9498 5.52422 9.25814 6.36589 8.39147L13.8826 15.9081ZM5.19089 7.21647C4.74922 7.67481 4.24089 8.0748 3.68255 8.39147C3.89922 7.7498 4.20755 7.15814 4.59089 6.61647L5.19089 7.21647Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_14203_4584">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoFace;
